import script from "./callMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./callMessage.vue?vue&type=script&setup=true&lang=ts"

import "./callMessage.vue?vue&type=style&index=0&id=d4fa1e20&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4fa1e20"]])

export default __exports__